 import React, { useEffect, useState } from "react";
import MetaTags from "../components/MetaTags";
import { getOrganizationSchema, getWebsiteSchema } from "../config/seo";
import { useDisclosure } from "@chakra-ui/react";
import { useRouter } from "next/router";
import NextLink from "next/link";
import ContactModal from "../components/contactModal";
import DemoSignupForm from "../components/demoSignupModal";
import api from "../config/axios";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Heading,
  Container,
  Text,
  Button,
  Stack,
  useColorModeValue,
  SimpleGrid,
  Flex,
  VStack,
  Stat,
  StatLabel,
  StatNumber,
  Link,
  IconButton,
  Badge,
} from "@chakra-ui/react";

import Image from "next/image";
import { BsPerson, BsShieldCheck, BsGraphUp, BsClock } from "react-icons/bs";
import { FiServer, FiUsers, FiBriefcase, FiAward } from "react-icons/fi";
import { MdWorkOutline, MdSecurity, MdSpeed, MdEco } from "react-icons/md";
import { FaQuoteLeft, FaArrowRight, FaCertificate, FaRocket } from "react-icons/fa";
import { Icon } from "@chakra-ui/react";
import Footer from "../components/footer";
import aicover from "../public/assets/AiCoverimage.png";
import Chatbot from "./chatbot";

function StatsCard(props) {
  const { title, stat, icon } = props;
  return (
    <Stat
      px={{ base: 2, md: 4 }}
      py={"5"}
      shadow={"xl"}
      border={"1px solid"}
      borderColor={useColorModeValue("gray.800", "gray.500")}
      rounded={"lg"}
    >
      <Flex justifyContent={"space-between"}>
        <Box pl={{ base: 2, md: 4 }}>
          <StatLabel fontWeight={"medium"} isTruncated>
            {title}
          </StatLabel>
          <StatNumber fontSize={"2xl"} fontWeight={"medium"}>
            {stat}
          </StatNumber>
        </Box>
        <Box
          my={"auto"}
          color={useColorModeValue("gray.800", "gray.200")}
          alignContent={"center"}
        >
          {icon}
        </Box>
      </Flex>
    </Stat>
  );
}

export default function Home() {
  const [totalUser, setTotalUser] = useState(0);
  const [assessmentUser, setAssessmentUser] = useState(0);
  const [jobsPosted, setJobsPosted] = useState(0);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [activeIndex, setActiveIndex] = useState(1);
  const [isModalOpen, setModalOpen] = useState(false);
  const router = useRouter();

  const closeModal = () => setModalOpen(false);

  const handleSeeDetailsClick = (type) => {
    setModalOpen(type);
  };

  useEffect(() => {
    // Fetch data for "Total users" from your backend API
    api
      .get("/get_total_users", { responseType: "json" })
      .then((response) => {
        const data = response.data;
        console.log("API Response for Total Users:", data);
        setTotalUser(data.total_users_count || 0);
      })
      .catch((error) => {
        console.error("Error fetching Total users:", error);
      });

    // Fetch data for "Assessments users" from your backend API
    api
      .get("/count_Assessed_Professionals", { responseType: "json" })
      .then((response) => {
        const data = response.data;
        console.log("API Response for Total Assessments:", data);
        setAssessmentUser(data.user_id_count || 0);
      })
      .catch((error) => {
        console.error("Error fetching Trusted By:", error);
      });

    // Fetch data for "Jobs Posted" from your backend API
    api
      .get("/total_job", { responseType: "json" })
      .then((response) => {
        const data = response.data;
        const totalJobs = data.total_jobs || 0;
        const deprecatedJobs = data.deprecated_jobs || 0;
        const opportunities = totalJobs - deprecatedJobs; // Calculate opportunities
        console.log("API Response for Opportunities:", opportunities);
        setJobsPosted(opportunities); // Set opportunities count
      })
      .catch((error) => {
        console.error("Error fetching Jobs Posted:", error);
      });
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    const validHashes = [
      "#testimonials-section",
      "#aptofy-edge-section",
      "#aptofy-offerings-section",
    ];

    if (validHashes.includes(hash)) {
      setTimeout(() => {
        const elementId = hash.substring(1);
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, []);

  const testimonials = [
    {
      id: 1,
      text: "Aptofy helps us connect and select top talent effortlessly. Recruitment is no longer a burden—it's smooth and efficient!",
    },
    {
      id: 2,
      text: "With Aptofy, we've seamlessly connected with exceptional candidates worldwide. The flexibility to conduct interviews anytime has streamlined our hiring, making it convenient and more efficient.",
    },
    {
      id: 3,
      text: "Aptofy made my interview process remarkably simple! With fewer tech rounds and a hassle-free experience. I felt supported and confident throughout and was thrilled to be selected.",
    },
    {
      id: 4,
      text: "Concept of the product is promising. It will really help in Hiring.",
    },
    {
      id: 5,
      text: "I think the Aptofy platform is well made!",
    },
  ];

  const handleNext = () => {
    setActiveIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const features = [
    {
      icon: <BsShieldCheck size="40px" color="#3A56D4" />,
      title: "Fake Candidate Detection",
      percentage: "99%",
      description: "Advanced AI algorithms detect and prevent fake profiles",
    },
    {
      icon: <MdSecurity size="40px" color="#3A56D4" />,
      title: "Proctored Assessments",
      percentage: "100%",
      description: "Complete monitoring and security during assessments",
    },
    {
      icon: <FiAward size="40px" color="#3A56D4" />,
      title: "Comprehensive Evaluation",
      percentage: "99% Accuracy",
      description: "Detailed analysis of technical and soft skills",
    },
  ];

  const benefits = [
    {
      icon: <BsClock size="32px" color="#3A56D4" />,
      title: "24/7 Availability",
      percentage: "300%",
      description: "Round-the-clock interview scheduling and assessment",
    },
    {
      icon: <BsShieldCheck size="32px" color="#3A56D4" />,
      title: "100% Bias-Free Hiring",
      percentage: "100%",
      description: "AI eliminates human bias for fair evaluations",
    },
    {
      icon: <MdEco size="32px" color="#3A56D4" />,
      title: "Carbon Footprint Reduction",
      percentage: "30%",
      description: "Reduce environmental impact with virtual assessments",
    },
    {
      icon: <BsGraphUp size="32px" color="#3A56D4" />,
      title: "Cost Reduction",
      percentage: "33%",
      description: "Significant savings in recruitment costs",
    },
  ];

  // Structured data for homepage
  const structuredData = [
    getOrganizationSchema(),
    getWebsiteSchema(),
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Aptofy",
      applicationCategory: "BusinessApplication",
      operatingSystem: "Web",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
      description: "Aptofy is a patented AI hiring platform that cuts carbon emissions by 50–99% while delivering accurate, bias-free, real-time candidate evaluations.",
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.8",
        reviewCount: totalUser > 0 ? totalUser.toString() : "1000+",
      },
    },
  ];

  return (
    <>
      <MetaTags
        title="Aptofy | Patented AI Hiring Platform - Carbon-Efficient Recruitment"
        description="Aptofy is a patented AI hiring platform that cuts carbon emissions by 50–99% while delivering accurate, bias-free, real-time candidate evaluations."
        keywords="Aptofy, AI hiring platform, patented recruitment technology, carbon-efficient hiring, bias-free assessments, real-time candidate evaluation, sustainable recruitment, AI interview automation, talent acquisition platform"
        url="https://www.aptofy.com/"
        image="https://www.aptofy.com/assets/aptofy.png"
        structuredData={structuredData}
      />

      <Chatbot />

      {/* Hero Section */}
      <Box
        bgGradient={useColorModeValue(
          "linear(to-br, #f7fafc, #edf2f7)",
          "linear(to-br, #1a202c, #2d3748)"
        )}
        minH="100vh"
        display="flex"
        alignItems="center"
        position="relative"
        overflow="hidden"
      >
        <Box
          position="absolute"
          top="0"
          left="0"
          right="0"
          bottom="0"
          opacity="0.03"
          bgGradient="radial(circle at 20% 80%, #3A56D4 0%, transparent 50%), radial(circle at 80% 20%, #3A56D4 0%, transparent 50%)"
        />

        <Container maxW="7xl" px={4} py={20}>
          <Flex
            direction={{ base: "column", md: "column", lg: "row" }}
            align="center"
            gap={16}
            position="relative"
            zIndex={1}
          >
            <Box
              flex="1"
              textAlign={{ base: "center", md: "center", lg: "left" }}
            >
            <VStack spacing={3} align={{ base: "center", lg: "flex-start" }} mb={6}>
              <Badge
                colorScheme="blue"
                variant="subtle"
                px={4}
                py={2}
                borderRadius="full"
                fontSize="sm"
                fontWeight="medium"
                display="flex"
                alignItems="center"
                gap={2}
                w="fit-content"
              >
                <Icon as={FaCertificate} boxSize={4} color="yellow.500" />
                PATENTED® AI Talent Evaluation
              </Badge>
              <Badge
                colorScheme="blue"
                variant="subtle"
                px={4}
                py={2}
                borderRadius="full"
                fontSize="sm"
                fontWeight="medium"
                display="flex"
                alignItems="center"
                gap={2}
                w="fit-content"
              >
                <Icon as={FaRocket} boxSize={4} color="#3A56D4" />
                Proctored AI Recruitment
              </Badge>
            </VStack>
<Heading
  as="h1"
  size={{ base: "2xl", md: "3xl", lg: "4xl" }}
  fontWeight="800"
  color={useColorModeValue("gray.800", "white")}
  mb={6}
  lineHeight="1.2"
>
  The Low-Carbon{" "}
  <Text as="span" whiteSpace="nowrap">AI Agent</Text>{" "}
  <Text as="span" color="#3A56D4">
    Redefining Modern Hiring
  </Text>{" "}
  — Quietly and Effectively
</Heading>

              <Text
                fontSize={{ base: "lg", md: "xl" }}
                color={useColorModeValue("gray.600", "gray.300")}
                mb={8}
                lineHeight="1.6"
                maxW="600px"
                mx={{ base: "auto", lg: "0" }}
              >
                Our AI Agent conducts interviews autonomously in a cheat-proof, real-time evaluation environment — questioning, scoring, and delivering accurate, bias-free results with comprehensive reports.
              </Text>

              <Stack
                direction={{ base: "column", sm: "row" }}
                spacing={4}
                justify={{ base: "center", lg: "flex-start" }}
              >
                <Button
                  onClick={onOpen}
                  size="lg"
                  bg="#3A56D4"
                  color="white"
                  px={8}
                  py={6}
                  borderRadius="full"
                  fontSize="lg"
                  fontWeight="600"
                  _hover={{
                    bg: "#2A46B0",
                    transform: "translateY(-2px)",
                    boxShadow: "xl",
                  }}
                  transition="all 0.3s ease"
                  rightIcon={<FaArrowRight />}
                >
                  Request Demo
                </Button>
                <Button
                  onClick={() => router.push("/directTrialpage")}
                  size="lg"
                  variant="outline"
                  borderColor="#3A56D4"
                  color="#3A56D4"
                  px={8}
                  py={6}
                  borderRadius="full"
                  fontSize="lg"
                  fontWeight="600"
                  _hover={{
                    bg: "#3A56D4",
                    color: "white",
                    transform: "translateY(-2px)",
                    boxShadow: "xl",
                  }}
                  transition="all 0.3s ease"
                >
                  Start Free Trial
                </Button>
              </Stack>
            </Box>

            <Box flex="1" maxW="600px">
              <Box
                position="relative"
                borderRadius="2xl"
                overflow="hidden"
                boxShadow="2xl"
                transform="rotate(2deg)"
                transition="transform 0.3s ease"
                _hover={{
                  transform: "rotate(0deg) scale(1.02)",
                }}
              >
                <Image
                  src={aicover}
                  alt="Aptofy AI Recruitment Platform"
                  width={600}
                  height={400}
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "1rem",
                  }}
                />
                <Box
                  position="absolute"
                  top="-10px"
                  right="-10px"
                  bg={useColorModeValue("white", "gray.700")}
                  borderRadius="full"
                  p={3}
                  boxShadow="lg"
                  transform="rotate(-15deg)"
                >
                  <BsShieldCheck size="24px" color="#3A56D4" />
                </Box>
                <Box
                  position="absolute"
                  bottom="-10px"
                  left="-10px"
                  bg={useColorModeValue("white", "gray.700")}
                  borderRadius="full"
                  p={3}
                  boxShadow="lg"
                  transform="rotate(15deg)"
                >
                  <FiAward size="24px" color="#3A56D4" />
                </Box>
              </Box>
            </Box>
          </Flex>
        </Container>
      </Box>

      {/* Value Proposition Sections */}
      <Box
        py={{ base: 16, md: 20 }}
        bg={useColorModeValue("gray.50", "gray.900")}
      >
        <Container maxW="6xl" px={4}>
          <VStack spacing={{ base: 10, md: 14 }} align="stretch">
            {/* Inclusive Hiring Section */}
            <Box
              textAlign="center"
              maxW="3xl"
              mx="auto"
              px={4}
            >
              <Text
                fontSize={{ base: "md", md: "lg", lg: "xl" }}
                color={useColorModeValue("gray.600", "gray.300")}
                lineHeight="1.7"
                fontWeight="400"
                mb={6}
              >
                Talent Acquisition Shouldn't Cost the Planet. Calculate the carbon footprint of your talent evaluation process
              </Text>
              <Button
                as={NextLink}
                href="/carbonEmission"
                colorScheme="green"
                size={{ base: "md", md: "lg" }}
                px={8}
                py={6}
                fontSize={{ base: "sm", md: "md" }}
                fontWeight="semibold"
                borderRadius="md"
                _hover={{
                  transform: "translateY(-2px)",
                  boxShadow: "lg",
                }}
                transition="all 0.2s"
              >
                Calculate Carbon Footprint
              </Button>
            </Box>

            {/* Recruit Smarter Section */}
            <Box
              bgGradient={useColorModeValue(
                "linear(to-r, #3A56D4, #5A76E4)",
                "linear(to-r, #3A56D4, #5A76E4)"
              )}
              borderRadius="xl"
              p={{ base: 8, md: 10 }}
              textAlign="center"
              boxShadow="xl"
              maxW="4xl"
              mx="auto"
              w="100%"
              position="relative"
              overflow="hidden"
            >
              <Box
                position="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                bgGradient="radial(circle at 50% 50%, rgba(255,255,255,0.1) 0%, transparent 70%)"
                pointerEvents="none"
              />
              <VStack spacing={4} position="relative" zIndex={1}>
                <Heading
                  as="h2"
                  size={{ base: "lg", md: "xl" }}
                  fontWeight="700"
                  color="white"
                  lineHeight="1.3"
                >
                  Recruit smarter. Move faster. Spend less.
                </Heading>
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="rgba(255, 255, 255, 0.95)"
                  lineHeight="1.6"
                  maxW="2xl"
                  mx="auto"
                >
                  Aptofy makes talent acquisition efficient, scalable, and cost-optimized, so your teams can focus on strategic growth — not scheduling calls.
                </Text>
              </VStack>
            </Box>

            {/* Quiet Technology Section */}
            <Box
              textAlign="center"
              maxW="2xl"
              mx="auto"
              px={4}
              pt={4}
            >
              <Box
                position="relative"
                display="inline-block"
                _before={{
                  content: '""',
                  position: "absolute",
                  top: "50%",
                  left: "-60px",
                  width: "50px",
                  height: "2px",
                  bg: useColorModeValue("#3A56D4", "#5A76E4"),
                  transform: "translateY(-50%)",
                  display: { base: "none", md: "block" },
                }}
                _after={{
                  content: '""',
                  position: "absolute",
                  top: "50%",
                  right: "-60px",
                  width: "50px",
                  height: "2px",
                  bg: useColorModeValue("#3A56D4", "#5A76E4"),
                  transform: "translateY(-50%)",
                  display: { base: "none", md: "block" },
                }}
              >
                <Heading
                  as="h3"
                  size={{ base: "lg", md: "xl" }}
                  fontWeight="700"
                  color={useColorModeValue("gray.800", "white")}
                  letterSpacing="0.02em"
                  lineHeight="1.4"
                  display="flex"
                  flexDirection={{ base: "column", sm: "row" }}
                  alignItems="center"
                  justifyContent="center"
                  gap={2}
                >
                  <Text as="span" color="#3A56D4">
                    Quiet Technology.
                  </Text>
                  <Text as="span">
                    Powerful Talent Decisions.
                  </Text>
                </Heading>
              </Box>
            </Box>
          </VStack>
        </Container>
      </Box>

      {/* Features Section */}
      <Box
        py={20}
        bg={useColorModeValue("white", "gray.800")}
        id="aptofy-edge-section"
      >
        <Container maxW="7xl" px={4}>
          <VStack spacing={16}>
            <Box textAlign="center" maxW="3xl">
              <Badge
                colorScheme="blue"
                variant="subtle"
                px={4}
                py={2}
                borderRadius="full"
                mb={4}
                fontSize="sm"
                fontWeight="medium"
              >
                ✨ Key Features
              </Badge>
              <Heading
                as="h2"
                size={{ base: "2xl", md: "3xl" }}
                fontWeight="700"
                color={useColorModeValue("gray.800", "white")}
                mb={6}
              >
                The Aptofy Edge
              </Heading>
              <Text
                fontSize="xl"
                color={useColorModeValue("gray.600", "gray.300")}
                lineHeight="1.6"
              >
                Cutting-edge AI technology that transforms your recruitment
                process
              </Text>
            </Box>

            <SimpleGrid
              columns={{ base: 1, sm: 1, md: 3 }}
              spacing={8}
              w="100%"
            >
              {features.map((feature, index) => (
                <Box
                  key={index}
                  p={8}
                  borderRadius="2xl"
                  bg={useColorModeValue("white", "gray.700")}
                  boxShadow="xl"
                  border="1px solid"
                  borderColor={useColorModeValue("gray.100", "gray.600")}
                  textAlign="center"
                  transition="all 0.3s ease"
                  _hover={{
                    transform: "translateY(-10px)",
                    boxShadow: "2xl",
                    borderColor: "#3A56D4",
                  }}
                >
                  <Box mb={6}>{feature.icon}</Box>
                  <Heading
                    size="lg"
                    mb={2}
                    color={useColorModeValue("gray.800", "white")}
                  >
                    {feature.title}
                  </Heading>
                  <Badge
                    colorScheme="green"
                    variant="solid"
                    px={3}
                    py={1}
                    borderRadius="full"
                    mb={4}
                    fontSize="sm"
                    fontWeight="600"
                  >
                    {feature.percentage}
                  </Badge>
                  <Text
                    color={useColorModeValue("gray.600", "gray.300")}
                    lineHeight="1.6"
                  >
                    {feature.description}
                  </Text>
                </Box>
              ))}
            </SimpleGrid>
          </VStack>
        </Container>
      </Box>

          {/* Measurable Impact Section */}
      <Box py={20} bg={useColorModeValue("gray.50", "gray.900")}>
        <Container maxW="7xl" px={4}>
          <VStack spacing={16}>
            <Box textAlign="center" maxW="3xl">
              <Badge
                colorScheme="green"
                variant="subtle"
                px={4}
                py={2}
                borderRadius="full"
                mb={4}
                fontSize="sm"
                fontWeight="medium"
              >
                📈 Measurable Impact
              </Badge>
              <Heading
                as="h2"
                size={{ base: "2xl", md: "3xl" }}
                fontWeight="700"
                color={useColorModeValue("gray.800", "white")}
                mb={6}
              >
                Measurable Impact on Your Business
              </Heading>
              <Text
                fontSize="xl"
                color={useColorModeValue("gray.600", "gray.300")}
                lineHeight="1.6"
              >
                Transform your recruitment process with quantifiable results
                that drive business success
              </Text>
            </Box>

            <SimpleGrid
              columns={{ base: 1, sm: 2, md: 3, lg: 4 }}
              spacing={6}
              w="100%"
            >
              {[
                {
                  title: "Proctored 100%",
                  description:
                    "Complete assessment security with AI-powered proctoring",
                  icon: "🛡️",
                },
                 {
                   title: "Bias-Free Results",
                   description: "Eliminate unconscious bias in hiring decisions",
                   icon: "🎯",
                 },
                {
                  title: "carbon emission reduction by 90% and more",
                  description:
                    "Significantly reduce your carbon footprint through digital assessments",
                  icon: "🌱",
                },
                {
                  title: "Reduce Time to hire to 30%",
                  description:
                    "Accelerate your hiring process with AI-powered evaluations",
                  icon: "⏱️",
                },
                {
                  title: "Cheat-Proof Environment",
                  description:
                    "Advanced AI monitoring ensures assessment integrity",
                  icon: "🔒",
                },
                {
                  title: "AI Agent Interviewing",
                  description:
                    "Conduct interviews with 0% human intervention and 100% customizable questions",
                  icon: "🤖",
                },
                {
                  title: "Real-time Evaluation",
                  description:
                    "Instant scoring and comprehensive candidate assessment report consisting verbal , non verbal and written communication skills",
                  icon: "📊",
                },
                {
                  title: "Individual Investment",
                  description:
                    "Personalized candidate development and skill assessment",
                  icon: "👤",
                },
              ].map((item, idx) => (
                <Box
                  key={idx}
                  p={6}
                  borderRadius="xl"
                  bg={useColorModeValue("white", "gray.700")}
                  boxShadow="lg"
                  border="1px solid"
                  borderColor={useColorModeValue("gray.200", "gray.600")}
                  transition="all 0.3s ease"
                  _hover={{
                    transform: "translateY(-5px)",
                    boxShadow: "xl",
                    borderColor: "#3A56D4",
                  }}
                  textAlign="center"
                >
                  <Text fontSize="3xl" mb={3}>
                    {item.icon}
                  </Text>
                  <Heading
                    as="h3"
                    size="md"
                    fontWeight="600"
                    color={useColorModeValue("gray.800", "white")}
                    mb={3}
                  >
                    {item.title}
                  </Heading>
                  <Text
                    fontSize="sm"
                    color={useColorModeValue("gray.600", "gray.300")}
                    lineHeight="1.5"
                  >
                    {item.description}
                  </Text>
                </Box>
              ))}
            </SimpleGrid>
          </VStack>
        </Container>
      </Box>

      {/* Testimonials Section */}
      <Box
        py={20}
        bg={useColorModeValue("white", "gray.800")}
        id="testimonials-section"
      >
        <Container maxW="7xl" px={4}>
          <VStack spacing={12}>
            <Box textAlign="center" maxW="3xl">
              <Badge
                colorScheme="purple"
                variant="subtle"
                px={4}
                py={2}
                borderRadius="full"
                mb={4}
                fontSize="sm"
                fontWeight="medium"
              >
                💬 Testimonials
              </Badge>
              <Heading
                as="h2"
                size={{ base: "2xl", md: "3xl" }}
                fontWeight="700"
                color={useColorModeValue("gray.800", "white")}
                mb={6}
              >
                The Aptofy Impact: Genuine Experiences, Proven Results
              </Heading>
            </Box>

            {/* Carousel Container */}
            <Box
              position="relative"
              h={{ base: "280px", md: "350px" }}
              overflow="hidden"
              w="100%"
            >
              <Flex
                width="100%"
                height="full"
                justifyContent="center"
                alignItems="center"
                position="relative"
              >
                {testimonials.map((testimonial, index) => {
                  let position = index - activeIndex;
                  if (position < -1) position += testimonials.length;
                  if (position > testimonials.length - 1)
                    position -= testimonials.length;

                  const isActive = index === activeIndex;
                  const translateX = position * 300;
                  const scale = isActive ? 1 : 0.85;
                  const opacity =
                    Math.abs(position) <= 1 ? (isActive ? 1 : 0.6) : 0;
                  const zIndex = isActive
                    ? 10
                    : Math.abs(position) <= 1
                    ? 5
                    : 1;

                  return (
                    <Box
                      key={testimonial.id}
                      position="absolute"
                      transition="all 0.6s ease-in-out"
                      transform={`translateX(${translateX}px) scale(${scale})`}
                      opacity={opacity}
                      zIndex={zIndex}
                      width={{ base: "250px", md: "300px" }}
                      maxW="90vw"
                      pointerEvents={isActive ? "auto" : "none"}
                    >
                       <Box
                         textAlign="center"
                         px={{ base: 3, md: 6 }}
                         py={{ base: 4, md: 6 }}
                         border="1px solid"
                         borderColor={useColorModeValue("#e2e8f0", "gray.600")}
                         borderRadius="xl"
                         boxShadow={isActive ? "xl" : "md"}
                         bg={useColorModeValue("white", "gray.700")}
                         minHeight={{ base: "160px", md: "200px" }}
                         display="flex"
                         alignItems="center"
                         justifyContent="center"
                       >
                         <Text
                           fontSize={{ base: "sm", md: "lg" }}
                           fontStyle="italic"
                           color={useColorModeValue("gray.700", "gray.300")}
                           lineHeight="1.6"
                         >
                          "{testimonial.text}"
                        </Text>
                      </Box>
                    </Box>
                  );
                })}
              </Flex>
            </Box>

            {/* Navigation Buttons */}
            <Flex justify="center" mt={4} gap={2}>
              <IconButton
                onClick={handlePrev}
                aria-label="Previous testimonial"
                icon={<ChevronLeftIcon />}
                colorScheme="blue"
                size={{ base: "sm", md: "md" }}
                variant="outline"
              />
              <IconButton
                onClick={handleNext}
                aria-label="Next testimonial"
                icon={<ChevronRightIcon />}
                colorScheme="blue"
                size={{ base: "sm", md: "md" }}
                variant="outline"
              />
            </Flex>
          </VStack>
        </Container>
      </Box>
  

      <Box
        maxW="7xl"
        mx={"auto"}
        pt={5}
        px={{ base: 2, sm: 12, md: 17 }}
        mt={50}
      >
        <Heading
          // chakra.h1
          textAlign={"center"}
          fontSize={"4xl"}
          py={10}
          fontWeight={"bold"}
          color="#3B58D7"
        >
          Join the growth wave! Amplify your company's success with Aptofy
        </Heading>
        {/* <Text textAlign={'center'} fontSize={'xl'} py={2}>
      instead of Users  - Trusted By , Assessed Professionals , countries
      </Text><br/> */}
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 5, lg: 8 }}>
          <StatsCard
            title={"Trusted By"}
            stat={totalUser}
            icon={<BsPerson size={"3em"} />}
          />
          <StatsCard
            title={"Assessed Professionals"}
            stat={assessmentUser}
            icon={<FiServer size={"3em"} />}
          />
          <StatsCard
            title={"Opportunities"}
            stat={jobsPosted}
            icon={<MdWorkOutline size={"3em"} />}
          />
        </SimpleGrid>
      </Box>

      {/* Aptofy Offerings Section */}
      <Box
        py={{ base: 14, md: 20 }}
        bg={useColorModeValue(
          "linear-gradient(180deg, #F7F9FF 0%, #FFFFFF 100%)",
          "linear-gradient(180deg, #111827 0%, #1F2937 100%)"
        )}
        id="aptofy-offerings-section"
      >
        <Container maxW="7xl" px={{ base: 4, md: 6 }}>
          <VStack spacing={{ base: 10, md: 14 }}>
            <Box textAlign="center" maxW="4xl">
              <Badge
                px={4}
                py={2}
                borderRadius="full"
                mb={4}
                fontSize="xs"
                fontWeight="700"
                letterSpacing="0.16em"
                textTransform="uppercase"
                color={useColorModeValue("#3A56D4", "#A5B4FC")}
                bg={useColorModeValue("rgba(58,86,212,0.12)", "rgba(165,180,252,0.18)")}
              >
                What We Offer
              </Badge>
              <Heading
                as="h2"
                fontSize={{ base: "3xl", md: "4xl" }}
                fontWeight="800"
                color={useColorModeValue("#101828", "white")}
                mb={5}
                lineHeight="1.15"
              >
                The Aptofy Offerings
              </Heading>
              <Text
                fontSize={{ base: "md", md: "lg" }}
                color={useColorModeValue("gray.600", "gray.300")}
                lineHeight="1.8"
              >
                Unlock your organisation&apos;s true potential with Aptofy, the
                AI-powered recruitment solution that revolutionises the way you
                find, assess, and hire top talent.
              </Text>
            </Box>

            <SimpleGrid columns={{ base: 1, lg: 12 }} spacing={6} w="100%">
              <Box
                gridColumn={{ base: "span 1", lg: "span 7" }}
                p={{ base: 6, md: 8 }}
                borderRadius="3xl"
                bg={useColorModeValue("white", "gray.800")}
                boxShadow={useColorModeValue("0 20px 45px rgba(20, 30, 70, 0.12)", "xl")}
                border="1px solid"
                borderColor={useColorModeValue("rgba(58,86,212,0.18)", "gray.600")}
                transition="all 0.3s ease"
                _hover={{ transform: { base: "none", md: "translateY(-4px)" } }}
              >
                <Heading
                  as="h3"
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="800"
                  color={useColorModeValue("gray.800", "white")}
                  mb={4}
                  lineHeight="1.2"
                >
                  Discover Your Ideal Talent with Aptofy
                </Heading>
                <Text
                  fontSize={{ base: "sm", md: "md" }}
                  color={useColorModeValue("gray.600", "gray.300")}
                  lineHeight="1.8"
                  mb={6}
                >
                  Aptofy is your dedicated Talent Acquisition Specialist,
                  meticulously screening candidates and delivering comprehensive
                  evaluations. Our AI-driven bot conducts interviews for you,
                  ensuring every assessment is tailored to your specific needs.
                </Text>
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3} mb={6}>
                  <Text fontSize="sm" color={useColorModeValue("gray.700", "gray.200")}>
                    • Smart sourcing and screening
                  </Text>
                  <Text fontSize="sm" color={useColorModeValue("gray.700", "gray.200")}>
                    • Role-specific candidate shortlists
                  </Text>
                  <Text fontSize="sm" color={useColorModeValue("gray.700", "gray.200")}>
                    • AI-powered interview support
                  </Text>
                  <Text fontSize="sm" color={useColorModeValue("gray.700", "gray.200")}>
                    • Faster hiring cycle completion
                  </Text>
                </SimpleGrid>
                <Button
                  onClick={() => handleSeeDetailsClick(1)}
                  size={{ base: "md", md: "lg" }}
                  bg="linear-gradient(135deg, #3A56D4, #5B73E8)"
                  color="white"
                  px={7}
                  borderRadius="xl"
                  fontWeight="600"
                  _hover={{
                    bg: "linear-gradient(135deg, #2A46B0, #4A62D7)",
                    transform: { base: "none", md: "translateY(-2px)" },
                    boxShadow: "xl",
                  }}
                  transition="all 0.3s ease"
                  rightIcon={<FaArrowRight />}
                >
                  See Details
                </Button>
              </Box>

              <VStack gridColumn={{ base: "span 1", lg: "span 5" }} spacing={6}>
                <Box
                  w="100%"
                  p={{ base: 6, md: 7 }}
                  borderRadius="3xl"
                  bg={useColorModeValue("white", "gray.800")}
                  boxShadow={useColorModeValue("0 15px 35px rgba(20, 30, 70, 0.1)", "lg")}
                  border="1px solid"
                  borderColor={useColorModeValue("gray.100", "gray.600")}
                  transition="all 0.3s ease"
                  _hover={{
                    transform: { base: "none", md: "translateY(-4px)" },
                    borderColor: "#3A56D4",
                  }}
                >
                  <Heading as="h3" size="md" fontWeight="700" color={useColorModeValue("gray.800", "white")} mb={3}>
                    Interview as a Service with Aptofy - The AI bot
                  </Heading>
                  <Text fontSize="sm" color={useColorModeValue("gray.600", "gray.300")} lineHeight="1.8" mb={5}>
                    Assess candidates with accuracy, consistency, and speed while
                    reducing bias using Aptofy&apos;s structured interview framework.
                  </Text>
                  <Button
                    onClick={() => handleSeeDetailsClick(2)}
                    size="md"
                    bg="#3A56D4"
                    color="white"
                    borderRadius="xl"
                    px={6}
                    _hover={{ bg: "#2A46B0" }}
                    rightIcon={<FaArrowRight />}
                  >
                    See Details
                  </Button>
                </Box>

                <Box
                  w="100%"
                  p={{ base: 6, md: 7 }}
                  borderRadius="3xl"
                  bg={useColorModeValue("white", "gray.800")}
                  boxShadow={useColorModeValue("0 15px 35px rgba(20, 30, 70, 0.1)", "lg")}
                  border="1px solid"
                  borderColor={useColorModeValue("gray.100", "gray.600")}
                  transition="all 0.3s ease"
                  _hover={{
                    transform: { base: "none", md: "translateY(-4px)" },
                    borderColor: "#3A56D4",
                  }}
                >
                  <Heading as="h3" size="md" fontWeight="700" color={useColorModeValue("gray.800", "white")} mb={3}>
                    Elevate Training with AI-Powered Proctored Assessments
                  </Heading>
                  <Text fontSize="sm" color={useColorModeValue("gray.600", "gray.300")} lineHeight="1.8" mb={5}>
                    Secure, monitored assessments and interview-backed training
                    support that improve outcomes and employability at scale.
                  </Text>
                  <Button
                    onClick={() => handleSeeDetailsClick(3)}
                    size="md"
                    bg="#3A56D4"
                    color="white"
                    borderRadius="xl"
                    px={6}
                    _hover={{ bg: "#2A46B0" }}
                    rightIcon={<FaArrowRight />}
                  >
                    See Details
                  </Button>
                </Box>
              </VStack>
            </SimpleGrid>
          </VStack>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box py={20} bg={useColorModeValue("gray.50", "gray.900")}>
        <Container maxW="4xl" px={4}>
          <Box
            bg={useColorModeValue("white", "gray.800")}
            borderRadius="2xl"
            p={12}
            textAlign="center"
            boxShadow="xl"
            border="1px solid"
            borderColor={useColorModeValue("gray.100", "gray.600")}
          >
            <Heading
              as="h2"
              size={{ base: "xl", md: "2xl" }}
              fontWeight="700"
              color={useColorModeValue("gray.800", "white")}
              mb={6}
            >
              Ready to Transform Your Recruitment Process?
            </Heading>
            <Text
              fontSize="lg"
              color={useColorModeValue("gray.600", "gray.300")}
              mb={8}
              lineHeight="1.6"
            >
              Experience the evolution of talent acquisition with Aptofy's
              AI-powered platform
            </Text>
            <Stack
              direction={{ base: "column", sm: "row" }}
              spacing={4}
              justify="center"
            >
              <Button
                onClick={onOpen}
                size="lg"
                bg="#3A56D4"
                color="white"
                px={8}
                py={6}
                borderRadius="full"
                fontSize="lg"
                fontWeight="600"
                _hover={{
                  bg: "#2A46B0",
                  transform: "translateY(-2px)",
                  boxShadow: "xl",
                }}
                transition="all 0.3s ease"
                rightIcon={<FaArrowRight />}
              >
                Get Started Today
              </Button>
              <Button
                onClick={() => router.push("/contactPage")}
                size="lg"
                variant="outline"
                borderColor="#3A56D4"
                color="#3A56D4"
                px={8}
                py={6}
                borderRadius="full"
                fontSize="lg"
                fontWeight="600"
                _hover={{
                  bg: "#3A56D4",
                  color: "white",
                  transform: "translateY(-2px)",
                  boxShadow: "xl",
                }}
                transition="all 0.3s ease"
              >
                Contact Sales
              </Button>
            </Stack>
          </Box>
        </Container>
      </Box>

      <Footer />

      {/* Modals */}
      <DemoSignupForm isOpen={isOpen} onClose={onClose} />
      <ContactModal
        isOpen={isModalOpen !== false}
        onClose={closeModal}
        type={isModalOpen}
      />
    </>
  );
}
